import {TranslateLoader} from '@ngx-translate/core';
import {inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {APP_CONFIG} from './inject-tokens';
import {Observable} from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly config = inject(APP_CONFIG);

  getTranslation(lang: string): Observable<any> {
    const url = `${this.config.salesApiUrl}/translations?lang=${lang}`;
    return this.http.get<any>(url);
  }
}